// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3uuu_","title":"Header_title__2PQVP","left":"Header_left__1YmCv","clinicName":"Header_clinicName__6P84U"};